// 拿到封装好的网络请求工具包
import request from '../utils/request'
// 校验接口
export const getUserInfo = params => request({
  url: '/api/classify/getUserInfo',
  params,
  headers: { 'Token-Circus': window.localStorage.getItem("Token-Circus"), 'Unique-Ident': window.localStorage.getItem("umtId") }
})

export const getPageInfo = params => request({
  url: '/api/classify/getPageInfo',
  params,
  headers: { 'Token-Circus': window.localStorage.getItem("Token-Circus"), 'Unique-Ident': window.localStorage.getItem("umtId") }
})